/**
 * Suggerimenti mostrati durante il caricamento iniziale dell'app.
 * Vengono mescolati e mostrati a rotazione: per aggiungerne, toglierne o
 * cambiarli basta modificare questa lista.
 */
export const LOADING_TIPS: string[] = [
  'Salva i prodotti e i servizi che fatturi più spesso: li ritrovi già pronti quando crei una nuova fattura.',
  'Nel Piano fiscale trovi una stima di tasse e contributi da mettere da parte.',
  'Usa la ricerca globale per trovare in un attimo clienti, fatture e documenti.',
  'Le fatture che non hai ancora inviato restano nelle Bozze: riprendile quando vuoi.',
  'Nel calendario trovi le scadenze fiscali, e puoi aggiungere anche i tuoi impegni personali.',
  "Hai un dubbio fiscale? Apri un ticket al tuo commercialista direttamente dall'app nella sezione Chat.",
  'Nella sezione Guide trovi risposte rapide alle domande più comuni sul regime forfettario.',
  'Puoi scegliere lo stile del PDF dei tuoi preventivi. Provali tutti!',
  'Dalla scheda di un cliente vedi tutte le fatture ad egli collegate che hai emesso nel tempo.',
  'In Profilo > Organizzazione, puoi invitare collaboratori nel tuo account, per aiutarti nel lavoro quotidiano.',
  'Con la nostra app, puoi emettere fatture, preventivi e note di credito.',
  'Puoi duplicare fatture passate usando la funzione \"Duplica\"',
  'Il piano fiscale, per prevedere le tue tasse, considera solo le fatture incassate. Spuntale nella tabella Fatture inviate.',
  "Puoi annullare l'invio di una fattura fino a che è ancora in stato di ATTESA.",
  'Puoi caricare rapidamente Fatture XML create con altri gestionali dalla sezione Carica fatture XML.',
  'Crea fatture in pochissimi minuti usando la funzione Fattura Rapida!',
];
